import styled from 'styled-components'

export const StyledTrashButtonContainer = styled.div`
    height: 58px;
    display: flex;
    align-items: end;
    justify-content: center;
`
